import React from 'react';
import SarasPopup from '../../container/popup/SarasPopup';
import SarasList from '../../../library/repeater/list/SarasList';
import SarasFilterMenuItem from './SarasFilterMenuItem';
import SarasTrans from '../../notifications/SarasTrans';

const SarasFilterMenu = (props) => {
  const { onSelection, dataList, menuContainerClass, menuTrigger, onClose } = props;

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleSelection = (menu) => {
      if(onSelection) onSelection(anchorRef, menu);
      setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    setOpen(false);
    if(onClose) onClose(event);
  };

  const renderMenuTrigger = () => {
    // console.log("render trigger", menuTrigger);
    if(menuTrigger != null) {
      return menuTrigger;
    }
    else {
      return <span><SarasTrans value = "Menu" /></span>
    }
  }
  
  return (
      <>
        <span className={menuContainerClass || ''}>
          <span
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            {renderMenuTrigger()}
          </span>
        </span>
        <SarasPopup anchorRef={anchorRef} open={open} onClose={handleClose}>
          <div className='uiFilterMenu'>
            <div className='uiSubHeading'>
              <SarasTrans value="Select a Filter" />
            </div>
            <SarasList disablePadding dense
              className="uiMultiColList"
              style={{width: '100%'}} >
              {dataList.map((menu, index) => (
                <SarasFilterMenuItem 
                  menuRow={menu} 
                  key={index} 
                  onClick={(event) => handleSelection(menu)}
                />
              ))}
            </SarasList>
          </div>
        </SarasPopup>
      </>
  );
}

export default SarasFilterMenu;
